/* Banky Nieuw WP1.2 (Keuzebord #8 winkelwagen-lade, PLAN.md #8): kleine aanvulling op Halo's winkelwagenlade.
   Halo blijft openen, toevoegen (product-form), aantallen wijzigen (line-item-quantity) en de regels en de voet verversen.
   Dit script doet alleen wat Halo niet doet:
   - de delen met data-banky-cart-deel (verzendmeter, "Maak het compleet") verversen uit hetzelfde antwoord van de
     section rendering dat Halo bij cart:change meestuurt, zodat meter en aanvullers altijd bij de winkelwagen passen;
   - na variant:add bovenaan "Toegevoegd aan je winkelwagen!" met de productnaam tonen (tot de lade sluit), de regel
     kort in tint zetten en dezelfde melding aan schermlezers doorgeven. Voegt "Maak het compleet" meer tegelijk toe, dan
     noemt de bevestiging het hoofdproduct (detail.hoofd, de variant van de koopbox) met "en 1 extra" of "en N extra's"
     (teksten uit banky-cart-confirm), niet het laatste extraatje (slot 02-10, punt 7).
   - upsell 2e artikel, lade C (06-10-2026): het dealblok (data-banky-cart-deel="deal", snippets/banky-cart-deal.liquid)
     ververst mee; staat de bevestiging open met het dealblok direct eronder, dan krijgt de bevestiging de klasse
     banky-cart-bevestiging--met-deal (samen één kaart); na de einddatum van de actie (data-banky-deal-einde, Amsterdamse
     tijd) gaan alle onderdelen met data-banky-deal dicht, tegen een pagina die Shopify kort in de cache hield; meting
     zonder persoonsgegevens (window.dataLayer: banky_upsell_view één keer per pagina als de dealkaart half in beeld is,
     banky_upsell_klik bij "Pak je deal" en de plusknop van een kaart).
   - winkelwagen ronde 3 (Geert 19-10-2026; /Users/geert/banky-r1-werk/cart-ontwerp/ontwerp/BOUWPLAN.md en BOUWPLAN-r1.md
     "Wat de klant ziet" punt 4): geen balk boven de voordeelkaart meer na toevoegen, maar een chip "Toegevoegd" naast de
     titel (6 s), de nieuwe regel licht kort op, de statusregel meldt naam en nieuw totaal. Focus na "Pak je deal" naar de kop
     van de kaart, na de plus in "Maak het compleet" naar de regel die erbij kwam of groeide (nooit naar een plusknop: een
     tweede Enter voegt dan niets toe). Wordt verzending gratis, dan licht de voetregel onder Totaal één keer op.
   - variantkeuzes zonder zwarte rand na een klik of tik (Geert 19-10: "Ja mag je ook meenemen", zoals de brilpagina):
     html.banky-wijzer bij pointerdown, weg bij een toets (niet bij alleen Shift, Cmd, Ctrl of Alt). Dit script staat op
     elke pagina (de lade); de opmaak staat in banky-pagina-product.css en snippets/banky-quick-buy-styles.liquid.
   De aftelling "Bestel binnen …" komt van bankyDelivery() in assets/banky-sales.js; die pakt nieuwe regels zelf op.
   Geladen door snippets/banky-cart-drawer.liquid, één keer per pagina (Laadsnelheid, Geert 04-10-2026, werkstroom D: meter
   en lege staat laadden hem ook); de guard hieronder blijft als vangnet. */
(() => {
  if (window.bankyCart) return;

  // Variantkeuzes en duo-tegels: na een klik of tik geen focusrand, met het toetsenbord wel (teal, :focus-visible).
  const html = document.documentElement;
  document.addEventListener('pointerdown', () => html.classList.add('banky-wijzer'), {capture: true, passive: true});
  document.addEventListener('keydown', e => {
    if (e.metaKey || e.ctrlKey || e.altKey || ['Shift', 'Meta', 'Control', 'Alt', 'CapsLock'].includes(e.key)) return;
    html.classList.remove('banky-wijzer');
  }, {capture: true});

  const sectieId = el => {
    const sectie = el?.closest('.shopify-section');
    return sectie ? sectie.id.replace('shopify-section-', '') : null;
  };
  const lades = () => [...document.querySelectorAll('cart-drawer')];
  let laatste = null; // {titel, sleutel, tijd}

  /* Snelheidsronde 3 (WP snel3.5c, BESLUITEN 11d): foto's en betaaliconen in de lade staan als data-banky-src en data-banky-srcset
     (snippets/banky-lade-beeld.liquid en banky-betaaliconen.liquid) en laden pas als de lade opengaat, als de winkelwagenknop
     aangewezen, aangeraakt of met het toetsenbord bereikt wordt, of als Halo de inhoud van een open lade vervangt. */
  const laadBeelden = wortel => wortel.querySelectorAll('img[data-banky-src]').forEach(img => {
    if (img.dataset.bankySrcset) { img.srcset = img.dataset.bankySrcset; img.removeAttribute('data-banky-srcset'); }
    img.src = img.dataset.bankySrc; img.removeAttribute('data-banky-src');
  });
  const waakBeelden = lade => {
    if (lade.bankyBeelden) return;
    lade.bankyBeelden = new MutationObserver(() => { if (lade.hasAttribute('open')) laadBeelden(lade); });
    lade.bankyBeelden.observe(lade, {attributes: true, attributeFilter: ['open'], childList: true, subtree: true});
    if (lade.hasAttribute('open')) laadBeelden(lade);
  };
  lades().forEach(waakBeelden);
  const voorbereiden = e => { if (e.target instanceof Element && e.target.closest('[aria-controls="cart-drawer"]')) lades().forEach(laadBeelden); };
  for (const soort of ['pointerover', 'touchstart', 'focusin']) document.addEventListener(soort, voorbereiden, {passive: true, capture: true});

  function ververs(lade, html) {
    if (!html) return;
    const nieuw = new DOMParser().parseFromString(html, 'text/html');
    lade.querySelectorAll('[data-banky-cart-deel]').forEach(oud => {
      const naam = oud.getAttribute('data-banky-cart-deel');
      const vers = nieuw.querySelector(`[data-banky-cart-deel="${naam}"]`);
      if (vers) oud.replaceWith(document.importNode(vers, true));
    });
    koppel(lade);
  }

  /* Upsell 2e artikel (lade C). */
  const vandaag = () => { try { return new Intl.DateTimeFormat('sv-SE', {timeZone: 'Europe/Amsterdam'}).format(new Date()); } catch { return new Date().toISOString().slice(0, 10); } };
  const meet = (event, velden) => { try { (window.dataLayer = window.dataLayer || []).push({event, ...velden}); } catch {} };
  let dealGezien = false, dealIo = null;
  function koppel(lade) {
    // Na de laatste dag: alles van de actie dicht (de korting zelf rekent Shopify; de regels tonen die gewoon), en waar een
    // kaart een dealprijs had de gewone prijs en knopnaam terug (data-banky-deal-terug; toetsronde 06-10, L5).
    const einde = lade.querySelector('[data-banky-deal-einde]')?.getAttribute('data-banky-deal-einde') || '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(einde) && vandaag() > einde) {
      lade.querySelectorAll('[data-banky-deal]').forEach(el => { el.hidden = true; });
      lade.querySelectorAll('[data-banky-deal-terug]').forEach(el => { el.hidden = false; });
    }
    // Weergave van de voordeelkaart met een aanbod: één keer per pagina, zodra hij voor de helft in beeld is (lade open).
    const kaart = lade.querySelector('.banky-cart-deal--voordeel[data-banky-stand="aanbod"]:not([hidden])');
    if (!kaart || dealGezien || !('IntersectionObserver' in window)) return;
    dealIo ||= new IntersectionObserver(items => {
      const zicht = items.find(x => x.isIntersecting);
      if (!zicht || dealGezien) return;
      dealGezien = true;
      dealIo.disconnect();
      const el = zicht.target;
      meet('banky_upsell_view', {banky_plek: el.dataset.bankyPlekMeting || 'lade_dealkaart', banky_product: el.dataset.bankyProduct || '', banky_vooraf: '', banky_deal: true, banky_pct: Number(el.dataset.bankyDealPct) || 0, banky_variant: el.dataset.bankyDealVariant || ''});
    }, {threshold: 0.5});
    dealIo.disconnect();
    dealIo.observe(kaart);
  }
  // Klik op "Pak je deal" (voordeelkaart) of de plusknop van een rij in "Maak het compleet": vóór Halo's product-form. Ook
  // voor de focus na het toevoegen (bevestig): de kop van de kaart, of de regel die erbij kwam.
  let bron = null; // {soort: 'kaart' | 'lijst', variant, toets, tijd}
  let toetsInvoer = false;
  document.addEventListener('keydown', () => { toetsInvoer = true; }, true);
  document.addEventListener('pointerdown', () => { toetsInvoer = false; }, true);
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('cart-drawer, [data-banky-cart-pagina]')) return;
    const dealkaart = form.matches('.banky-cart-deal__form'), kaart = form.matches('.banky-cart-product__form');
    if (!dealkaart && !kaart) return;
    const blok = form.closest('.banky-cart-deal');
    const variant = form.querySelector('input[name="id"]')?.value || '';
    bron = {soort: dealkaart ? 'kaart' : 'lijst', variant, toets: toetsInvoer, tijd: Date.now()};
    if (!form.closest('cart-drawer')) return;
    meet('banky_upsell_klik', {
      banky_plek: dealkaart ? (form.dataset.bankyPlek || 'lade_dealkaart') : 'lade_kaart',
      banky_product: form.closest('cart-drawer')?.querySelector('[data-banky-cart-deel="deal"]')?.dataset.bankyProduct || '',
      banky_varianten: [variant], banky_totaal: Number(blok?.dataset.bankyDealMeer) || 0,
      banky_extra_korting: Number(blok?.dataset.bankyDealBedrag) || 0, banky_vooraf_behouden: false,
    });
  }, true);

  // Ronde 3: chip "Toegevoegd" naast de titel (6 s, aria-hidden: de statusregel zegt het), de nieuwe regel licht op, de
  // statusregel meldt naam ("en 1 extra" na Maak het compleet in de koopbox) en het nieuwe totaal, en de focus gaat na een
  // toevoeging vanuit de wagen naar de kop van de kaart of de regel die erbij kwam. Halo vervangt de lade soms in twee
  // stappen; bevestig loopt dan nog een keer en zet alles opnieuw, de focus en de melding één keer per toevoeging.
  const VINK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>';
  function chip(lade, tekst) {
    const titel = lade.querySelector('.banky-cart__kop .banky-cart__titel');
    if (!titel || !tekst) return;
    let c = titel.querySelector('.banky-cart__toegevoegd');
    if (!c) {
      c = document.createElement('span');
      c.className = 'banky-cart__toegevoegd';
      c.setAttribute('aria-hidden', 'true');
      c.innerHTML = VINK + '<span></span>';
      titel.append(c);
    }
    c.lastElementChild.textContent = tekst;
    clearTimeout(lade.bankyChip);
    lade.bankyChip = setTimeout(() => c.remove(), Math.max(0, 6000 - (Date.now() - laatste.tijd)));
  }
  // De rij van een variant: data-key is de sleutel van de eerste regel van die variant ("variant-id:..."), banky-cart-line.
  // Duo-bundels (21-10): een rij met een verborgen bundel van 2 stuks noemt beide varianten in data-banky-varianten.
  const rijVan = (lade, variant) => variant ? [...lade.querySelectorAll('line-item[data-key]')].find(r => String(r.dataset.key).split(':')[0] === variant || String(r.dataset.bankyVarianten || '').split(',').includes(variant)) : null;
  function bevestig(lade) {
    if (!laatste || Date.now() - laatste.tijd > 60000) return;
    const blok = lade.querySelector('[data-banky-cart-bevestiging]');
    const status = lade.querySelector('[data-banky-cart-status]');
    const vast = blok?.querySelector('[data-banky-cart-bevestiging-tekst]')?.textContent.trim() || '';
    let extra = '';
    if (laatste.extra > 0 && blok) {
      const sjabloon = laatste.extra === 1 ? blok.dataset.tekstExtra : blok.dataset.tekstExtras;
      if (sjabloon) extra = sjabloon.split('{aantal}').join(String(laatste.extra));
    }
    const naam = [laatste.titel, extra].filter(Boolean).join(' ');
    const sinds = Date.now() - laatste.tijd;
    if (sinds < 6000) chip(lade, blok?.dataset.tekstToegevoegd || '');
    koppel(lade);
    const totaal = lade.querySelector('.banky-cart__totaal span:last-child')?.textContent.trim() || '';
    const melding = [vast, naam, totaal && blok?.dataset.tekstTotaal ? `${blok.dataset.tekstTotaal} ${totaal}.` : ''].filter(Boolean).join(' ');
    if (status && status.textContent !== melding) status.textContent = melding;
    const rij = rijVan(lade, laatste.variant) || (laatste.sleutel ? lade.querySelector(`line-item[data-key="${CSS.escape(laatste.sleutel)}"]`) : null);
    if (rij && sinds < 2400) { rij.classList.add('is-nieuw'); setTimeout(() => rij.classList.remove('is-nieuw'), 2400 - sinds); }
  }
  // Focus na een toevoeging vanuit de wagen zelf (Pak je deal of een plus): de kop van de kaart of de regel die erbij kwam.
  // Pas na het verversen (kaart en lijst door ververs, regels door Halo met setTimeout 0), anders verdwijnt het element onder
  // de focus; nog één keer later voor Halo's tweede stap, daarna klaar (een volgende wijziging zet de focus niet nog eens).
  function zetFocus(lade, laatsteKeer) {
    if (!laatste || !laatste.bron || laatste.gefocust || !lade.hasAttribute('open')) return;
    const rij = rijVan(lade, laatste.variant);
    const kop = lade.querySelector('.banky-cart-deal--voordeel .banky-cart-deal__kop');
    const doel = laatste.bron.soort === 'kaart' && kop ? kop : rij || kop;
    if (doel && document.activeElement !== doel) {
      if (doel.matches('line-item') && !doel.hasAttribute('tabindex')) doel.setAttribute('tabindex', '-1');
      doel.focus({preventScroll: !laatste.bron.toets});
    }
    if (laatsteKeer) laatste.gefocust = true;
  }

  // Bij sluiten: de toevoeging is afgehandeld (geen chip of focus meer bij een volgende opening).
  document.addEventListener('dialog:after-hide', e => {
    if (!(e.target instanceof HTMLElement) || e.target.tagName !== 'CART-DRAWER') return;
    laatste = null;
    e.target.querySelector('.banky-cart__toegevoegd')?.remove();
    koppel(e.target);
  }, true);

  function naToevoegen(detail) {
    const items = Array.isArray(detail?.items) ? detail.items.filter(Boolean) : [];
    if (!items.length) return;
    const hoofd = detail.hoofd ? String(detail.hoofd) : '';
    const item = (hoofd && items.find(i => String(i.variant_id ?? i.id) === hoofd)) || items[0];
    const titel = [item.product_title || item.title, item.product_has_only_default_variant === false ? item.variant_title : null].filter(Boolean).join(' · ');
    const vanWagen = bron && Date.now() - bron.tijd < 15000 ? bron : null;
    bron = null;
    laatste = {titel, extra: items.length - 1, sleutel: item.key || null, variant: String(item.variant_id ?? item.id ?? ''), tijd: Date.now(), bron: vanWagen};
    lades().forEach(bevestig);
  }

  // Halo zet bij openen de focus in het eerste invoerveld. In de lege lade is dat het zoekveld; wie met de muis of
  // touch opent, krijgt de focus op de sluitknop, zodat het zoekveld niet ongevraagd actief oogt. Met het toetsenbord
  // blijft de focus waar Halo hem zet.
  let toetsenbord = false;
  document.addEventListener('keydown', () => { toetsenbord = true; }, true);
  document.addEventListener('pointerdown', () => { toetsenbord = false; }, true);
  document.addEventListener('dialog:after-show', e => {
    const lade = e.target;
    if (!(lade instanceof HTMLElement) || lade.tagName !== 'CART-DRAWER' || toetsenbord) return;
    const zet = () => { if (document.activeElement?.matches?.('.banky-cart-leeg__zoekveld')) lade.shadowRoot?.querySelector('[part="close-button"]')?.focus({preventScroll: true}); };
    zet(); requestAnimationFrame(zet);
  }, true);
  document.addEventListener('dialog:after-show', e => { if (e.target instanceof HTMLElement && e.target.tagName === 'CART-DRAWER') koppel(e.target); }, true);

  document.addEventListener('variant:add', e => naToevoegen(e.detail));
  // Verzending net gratis: de voetregel licht één keer op (niet bij minder beweging). Gelezen vóór en na Halo's vervanging.
  const gratisNu = () => document.querySelector('cart-drawer .banky-cart-voetregel')?.dataset.bankyGratis === 'true';
  let wasGratis = null;
  const naGratis = () => {
    const v = document.querySelector('cart-drawer .banky-cart-voetregel');
    if (!v) return;
    const nu = v.dataset.bankyGratis === 'true';
    if (wasGratis === false && nu && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !v.classList.contains('banky-cart-voetregel--nieuw')) v.classList.add('banky-cart-voetregel--nieuw');
    if (wasGratis !== null && wasGratis !== nu) wasGratis = nu;
  };
  document.addEventListener('cart:change', () => { if (wasGratis === null) wasGratis = gratisNu(); }, true);
  document.addEventListener('cart:change', () => { setTimeout(naGratis, 0); setTimeout(() => { naGratis(); wasGratis = gratisNu(); }, 120); });
  document.addEventListener('cart:change', e => {
    const cart = e.detail?.cart;
    lades().forEach(lade => {
      const id = sectieId(lade);
      if (cart?.sections && id) ververs(lade, cart.sections[id]);
      // Halo vervangt de lade soms na een korte pauze; daarna de bevestiging opnieuw zetten.
      requestAnimationFrame(() => bevestig(lade));
      setTimeout(() => { bevestig(lade); zetFocus(lade, false); }, 60);
      setTimeout(() => zetFocus(lade, true), 400);
    });
  });

  // Ook bij het laden (de lade staat op elke pagina in de HTML) en na een volledige vervanging door Halo (eerste artikel).
  const start = () => lades().forEach(koppel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* ---- WP r1-zoek-kar (Geert 16-10, punten 3, 4, 6, 11 en 12) -------------------------------------------------------
     Eén rij per variant: banky-cart-line telt de regels op die Shopify door de automatische korting splitst. De teller en
     Verwijderen werken hier zonder herladen en zonder Halo's pauze van 1,25 s (line-item-quantity ververst de regels pas
     daarna): plus en min wijzigen één regel (de eerste of de laatste, het totaal gaat precies één omhoog of omlaag),
     Verwijderen zet alle regels van de variant in één verzoek op 0. Daarna dezelfde cart:change als na toevoegen, zodat
     Halo de lade meteen vult, de teller in de kop klopt en dit script meter en aanvullers ververst. Op /cart (de
     winkelwagenpagina, punt 12) vervangt het antwoord de sectie zelf, in plaats van Halo's volledige herlading.
     Fouten van Shopify (punt 3, 429 of 5xx): de verzoeken naar /cart/add.js, change.js en update.js krijgen bij een
     antwoord zonder JSON een nette melding in JSON terug, zodat Halo's product-form zijn gewone foutmelding toont in plaats
     van een scriptfout zonder melding; /cart.js lezen probeert het bij 429 of 5xx nog twee keer (live gezien: lade bleef dicht
     na een 429 op /cart.js). Ontbreekt de lade in het antwoord terwijl er wel artikelen zijn, dan toont de lade
     een noodstand met de artikelen en een link naar de winkelwagen en haalt hij zichzelf daarna opnieuw op: nooit meer
     "Je winkelwagen is leeg" bij een gevulde winkelwagen.
     Te weinig voorraad (punt 6): Shopify voegt dan toch toe wat er is en antwoordt 422. De melding zegt nu hoeveel stuks
     er echt in de winkelwagen staan, en lade en teller worden bijgewerkt. */
  const teksten = () => {
    const el = document.querySelector('[data-banky-cart-teksten]');
    const d = el ? el.dataset : {};
    return {fout: d.fout || 'Dat lukte even niet. Probeer het zo opnieuw.', bekijk: d.bekijk || '', voorraad: d.voorraad || '',
      totaal: d.totaal || '', titel: d.titel || '', afrekenen: d.afrekenen || '', cartUrl: d.cartUrl || '/cart'};
  };
  const wortelUrl = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const esc = t => String(t ?? '').replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const geld = centen => {
    const f = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    const [heel, deel] = (Math.abs(Number(centen) || 0) / 100).toFixed(2).split('.');
    return f.replace(/{{\s*amount_with_comma_separator\s*}}/, heel.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + deel)
      .replace(/{{\s*amount\s*}}/, heel.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + deel);
  };
  const echteFetch = window.fetch.bind(window);
  const wachten = ms => new Promise(r => setTimeout(r, ms));
  // GET met twee nieuwe pogingen bij 429 of 5xx (Shopify remt kort af; na 0,6 en 1,5 s lukt het meestal wel).
  async function haalOpnieuw(url, opties = {}) {
    let laatsteFout = null;
    for (const pauze of [0, 600, 1500]) {
      if (pauze) await wachten(pauze);
      try {
        const r = await echteFetch(url, opties);
        if (r.ok) return r;
        laatsteFout = new Error('status ' + r.status);
        if (r.status !== 429 && r.status < 500) break;
      } catch (fout) { laatsteFout = fout; }
    }
    throw laatsteFout || new Error('ophalen mislukt');
  }
  const ladeIds = () => lades().map(sectieId).filter(Boolean);
  async function haalCart(metSecties = []) {
    const cart = await (await haalOpnieuw(wortelUrl() + 'cart.js', {headers: {Accept: 'application/json'}})).json();
    const ids = [...new Set(metSecties.filter(Boolean))];
    if (ids.length) {
      try { cart.sections = await (await haalOpnieuw(wortelUrl() + '?sections=' + ids.map(encodeURIComponent).join(','))).json(); } catch { cart.sections = {}; }
    }
    return cart;
  }
  const verstuurWijziging = cart => document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {baseEvent: 'variant:add', cart}}));
  async function synchroniseer() {
    try {
      let cart = await haalCart([...ladeIds(), paginaSectieId()]);
      // Duo-bundels (review 21-10): ook na een deels geslaagde toevoeging (422) en bij het verversen het plan uitvoeren.
      const plan = planVanSecties(cart.sections);
      if (plan) {
        const nieuw = await duoUitvoeren(plan, [...new Set([...ladeIds(), paginaSectieId()].filter(Boolean))]);
        if (nieuw) { cart = nieuw; const pagina = paginaSectieId(); if (pagina && cart.sections && cart.sections[pagina]) vervangPagina(cart.sections[pagina]); }
      }
      verstuurWijziging(cart);
    } catch { /* volgende wijziging probeert het weer */ }
  }
  const variantUit = (body) => {
    try {
      if (body instanceof FormData) return body.get('id');
      if (typeof body === 'string') { const j = JSON.parse(body); return j.id || (Array.isArray(j.items) && j.items[0] && j.items[0].id) || null; }
    } catch {}
    return null;
  };
  const jsonAntwoord = (status, inhoud) => new Response(JSON.stringify(inhoud), {status, headers: {'Content-Type': 'application/json'}});

  /* ---- Duo-bundels (Geert 21-10-2026: "dat er alleen een switch plaats vind van een los product of naar een bundel (per 2).
     als je dan weer van 2 naar 1 gaat zouden we moeten kijken of er dan 1 product overblijft ipv dat de hele bundel dan
     weggaat"; besluit "Ja, bouwen"). Lade en winkelwagenpagina zetten na elke wijziging het plan van snippets/banky-duo-plan
     in hun HTML als twee stuks van een variant een verborgen bundel van 2 stuks moeten worden (of terug). Direct na een
     geslaagde add.js, change.js of update.js, voordat Halo of dit script iets toont, voert de fetch-laag hieronder dat plan
     uit met één update.js met dezelfde secties; het antwoord vervangt dan de secties (add.js) of het hele antwoord. Zo opent
     de lade meteen met de bundel en gaat Direct afrekenen ook met de bundel. Eén poging per wijziging; mislukt hij, dan blijft
     de winkelwagen zoals hij was (de stuks krijgen dan de korting van de actie). */
  const PLAN = /<script type="application\/json" data-banky-duo-plan>([\s\S]*?)<\/script>/;
  const planUit = html => {
    const m = typeof html === 'string' ? PLAN.exec(html) : null;
    if (!m) return null;
    try { const p = JSON.parse(m[1]); return p && p.updates && Object.keys(p.updates).length ? p : null; } catch { return null; }
  };
  const planVanSecties = secties => { for (const html of Object.values(secties || {})) { const p = planUit(html); if (p) return p; } return null; };
  // sections en sections_url uit het verzoek: FormData (Halo's product-form) of JSON-tekst (banky-product, banky-finder, de teller).
  function sectiesVan(body) {
    try {
      if (body instanceof FormData) return {sections: body.get('sections') || '', url: body.get('sections_url') || ''};
      if (typeof body === 'string') { const j = JSON.parse(body); return {sections: j.sections || '', url: j.sections_url || ''}; }
    } catch { /* geen secties */ }
    return {sections: '', url: ''};
  }
  let duoRij = Promise.resolve();
  async function duoWissel(r, soort, opties) {
    let json;
    try { json = await r.clone().json(); } catch { return r; }
    const plan = planVanSecties(json && json.sections);
    if (!plan) return r;
    const {sections, url} = sectiesVan(opties && opties.body);
    const body = {updates: plan.updates};
    if (sections && sections.length) body.sections = sections;
    if (url) body.sections_url = url;
    const stap = duoRij.then(async () => {
      try {
        const w = await echteFetch(wortelUrl() + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify(body)});
        if (!w.ok) return r;
        const nieuw = await w.json();
        if (soort === 'add') return jsonAntwoord(200, {...json, sections: nieuw.sections || json.sections});
        return jsonAntwoord(200, nieuw);
      } catch { return r; }
    });
    duoRij = stap.catch(() => {});
    return stap;
  }
  // Een plan uitvoeren met de gegeven secties (synchroniseer en duoBijLaden). Per plantekst houdt de sessie bij of Shopify het
  // definitief weigerde (4xx behalve 429), zodat zo'n plan niet blijft lopen; bij 429, 5xx of een netwerkfout volgt een
  // volgende keer een nieuwe poging. Antwoord: de winkelwagen met secties, of null.
  async function duoUitvoeren(plan, ids) {
    const sleutel = 'banky-duo-plan:' + JSON.stringify(plan.updates);
    try { if (sessionStorage.getItem(sleutel)) return null; } catch { /* zonder opslag gewoon proberen */ }
    const stap = duoRij.then(async () => {
      try {
        const w = await echteFetch(wortelUrl() + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify({updates: plan.updates, sections: ids})});
        if (!w.ok) {
          if (w.status >= 400 && w.status < 500 && w.status !== 429) { try { sessionStorage.setItem(sleutel, '1'); } catch { /* geen opslag */ } }
          return null;
        }
        return await w.json();
      } catch { return null; }
    });
    duoRij = stap.catch(() => {});
    return stap;
  }
  // Bij het laden (een winkelwagen van eerder, of een wijziging buiten dit script om): het plan in de pagina uitvoeren en lade
  // en pagina verversen.
  async function duoBijLaden() {
    const el = document.querySelector('script[data-banky-duo-plan]');
    if (!el) return;
    let plan;
    try { plan = JSON.parse(el.textContent); } catch { return; }
    if (!plan || !plan.updates || !Object.keys(plan.updates).length) return;
    const pagina = paginaSectieId();
    const cart = await duoUitvoeren(plan, [...new Set([...ladeIds(), pagina].filter(Boolean))]);
    if (!cart) return;
    if (pagina && cart.sections && cart.sections[pagina]) vervangPagina(cart.sections[pagina]);
    verstuurWijziging(cart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(duoBijLaden, 0)); else setTimeout(duoBijLaden, 0);
  // /cart.js lezen (Halo na toevoegen en bij het verversen van de lade, banky-product.js, banky-finder.js): bij 429 of 5xx
  // nog twee keer proberen, zoals haalOpnieuw; lukt het niet, dan het laatste antwoord zoals voorheen.
  async function leesCart(invoer, opties) {
    let r = null;
    for (const pauze of [0, 600, 1500]) {
      if (pauze) await wachten(pauze);
      try { r = await echteFetch(invoer, opties); } catch (fout) { if (pauze === 1500 || (fout && fout.name === 'AbortError')) throw fout; continue; }
      if (r.ok || (r.status !== 429 && r.status < 500)) return r;
    }
    return r;
  }
  window.fetch = async (invoer, opties = {}) => {
    let url;
    try { url = new URL(invoer instanceof Request ? invoer.url : String(invoer), location.href); } catch { return echteFetch(invoer, opties); }
    const methode = String((opties && opties.method) || (invoer instanceof Request ? invoer.method : 'GET')).toUpperCase();
    if (url.origin === location.origin && methode === 'GET' && /\/cart\.js$/.test(url.pathname)) return leesCart(invoer, opties);
    const soort = url.origin === location.origin && (/\/cart\/(add|change|update)\.js$/.exec(url.pathname) || [])[1];
    if (!soort) return echteFetch(invoer, opties);
    let r;
    try { r = await echteFetch(invoer, opties); } catch (fout) {
      if (fout && fout.name === 'AbortError') throw fout;
      return jsonAntwoord(503, {status: 503, message: 'Cart Error', description: teksten().fout});
    }
    if (r.ok) return /^(add|change|update)$/.test(soort) ? duoWissel(r, soort, opties) : r;
    let json = null;
    try { json = await r.clone().json(); } catch { /* 429 of 5xx met een HTML-pagina */ }
    if (r.status === 422 && soort === 'add') {
      const variant = String(variantUit(opties.body) || '');
      try {
        const cart = await haalCart();
        const n = (cart.items || []).filter(i => String(i.variant_id) === variant).reduce((t, i) => t + i.quantity, 0);
        const t = teksten();
        if (variant && n > 0 && t.voorraad) json = {...(json || {status: 422, message: 'Cart Error'}), description: t.voorraad.split('{aantal}').join(String(n))};
        // Na Halo's cart:error (melding bij de koopknop): lade en teller op wat er echt in de winkelwagen staat.
        setTimeout(synchroniseer, 60);
      } catch { /* melding van Shopify blijft */ }
      return jsonAntwoord(422, json || {status: 422, message: 'Cart Error', description: teksten().fout});
    }
    if (json && json.description) return jsonAntwoord(r.status, json);
    return jsonAntwoord(r.status, {status: r.status, message: 'Cart Error', description: teksten().fout});
  };

  // Noodstand van de lade: de artikelen uit cart.js, een melding en een link naar de winkelwagenpagina.
  function noodLade(cart) {
    const t = teksten();
    const rijen = (cart.items || []).map(i => `<div class="line-item banky-cart-regel"><span class="banky-cart-regel__beeld">${i.image ? `<img src="${esc(String(i.image).replace(/^\/\//, 'https://'))}" alt="" width="72" height="72" loading="lazy">` : ''}</span><div class="banky-cart-regel__info"><p class="banky-cart-regel__titel"><span class="banky-cart-regel__titeltekst">${esc(i.product_title || i.title)}</span></p>${i.product_has_only_default_variant === false && i.variant_title ? `<p class="banky-cart-regel__variant">${esc(i.variant_title)}</p>` : ''}<p class="banky-cart-regel__variant">${i.quantity} × ${esc(geld(i.final_line_price / i.quantity))}</p></div></div>`).join('');
    return `<div class="cart-drawer"><div slot="header" class="banky-cart__kop"><p class="banky-cart__titel">${esc(t.titel)} <cart-count class="banky-cart__aantal">${cart.item_count}</cart-count></p></div>`
      + `<div class="banky-cart"><p class="banky-cart-fout" data-banky-cart-fout="nood"><a href="${esc(t.cartUrl)}">${esc(t.bekijk)}</a></p><div class="cart-drawer__line-items banky-cart__regels">${rijen}</div></div>`
      + `<div slot="footer" class="banky-cart__voet"><div class="banky-cart__totalen"><p class="banky-cart__rij banky-cart__totaal"><span>${esc(t.totaal)}</span><span>${esc(geld(cart.total_price))}</span></p></div><a class="banky-btn--ink banky-cart__knop" href="${esc(wortelUrl())}checkout">${esc(t.afrekenen)}</a></div></div>`;
  }
  async function herlaadLade(lade, id) {
    try {
      const html = await (await haalOpnieuw(wortelUrl() + '?section_id=' + encodeURIComponent(id))).text();
      const tijdelijk = document.createElement('div');
      tijdelijk.innerHTML = html;
      const vers = tijdelijk.querySelector('#cart-drawer') || tijdelijk.querySelector('.cart-drawer');
      if (!vers || !vers.querySelector('.banky-cart')) return;
      lade.replaceChildren(...vers.children);
      koppel(lade);
      laadBeelden(lade);
      bevestig(lade);
    } catch { /* de noodstand blijft staan, met de link naar de winkelwagen */ }
  }
  // Vóór Halo (vangfase op document): een lade die in het antwoord ontbreekt nooit als lege winkelwagen tonen.
  document.addEventListener('cart:change', e => {
    const cart = e.detail && e.detail.cart;
    if (!cart || !(cart.item_count > 0)) return;
    lades().forEach(lade => {
      const id = sectieId(lade);
      if (!id) return;
      const html = cart.sections && cart.sections[id];
      if (typeof html === 'string' && html.includes('cart-drawer__line-items')) return;
      cart.sections = {...(cart.sections || {}), [id]: noodLade(cart)};
      setTimeout(() => herlaadLade(lade, id), 120);
    });
  }, true);
  document.addEventListener('cart:change', () => lades().forEach(l => l.querySelectorAll('[data-banky-cart-fout]:not([data-banky-cart-fout="nood"])').forEach(x => { if (!x.closest('.banky-cart-regel')) x.remove(); })));

  // Snel toevoegen op een kaart heeft geen koopknoppen om de melding bij te zetten (de koopbox en de snelkooplade wel,
  // Halo's BuyButtons): dan opent de lade met de melding bovenaan.
  document.addEventListener('cart:error', e => {
    const form = e.target instanceof HTMLFormElement ? e.target : null;
    if (!form) return;
    const id = form.getAttribute('id') || '';
    if (id && document.querySelector(`buy-buttons[form="${CSS.escape(id)}"]`)) return;
    const lade = lades()[0];
    if (!lade) return;
    const wortel = lade.querySelector('.banky-cart');
    if (!wortel) return;
    wortel.querySelector('[data-banky-cart-fout]')?.remove();
    const p = document.createElement('p');
    p.className = 'banky-cart-fout';
    p.setAttribute('role', 'alert');
    p.dataset.bankyCartFout = '';
    p.textContent = (e.detail && e.detail.error) || teksten().fout;
    wortel.prepend(p);
    if (typeof lade.show === 'function') lade.show();
  });
  document.addEventListener('dialog:after-hide', e => {
    if (e.target instanceof HTMLElement && e.target.tagName === 'CART-DRAWER') e.target.querySelectorAll('[data-banky-cart-fout]').forEach(x => x.remove());
  }, true);

  // Teller en Verwijderen in de lade en op de winkelwagenpagina (vangfase, dus vóór Halo's line-item-quantity).
  const paginaSectieId = () => sectieId(document.querySelector('[data-banky-cart-pagina]'));
  function regelFout(regel, tekst) {
    regel.querySelector('[data-banky-cart-fout]')?.remove();
    const p = document.createElement('p');
    p.className = 'banky-cart-fout';
    p.setAttribute('role', 'alert');
    p.dataset.bankyCartFout = '';
    p.textContent = tekst;
    regel.querySelector('.banky-cart-regel__info')?.append(p);
  }
  async function wijzigRegel(regel, link, verwijder) {
    if (regel.getAttribute('aria-busy') === 'true') return;
    const sleutels = (regel.dataset.bankySleutels || '').split(',').filter(Boolean);
    const u = new URL(link.href, location.href);
    const secties = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles: true, detail: {sections: secties}}));
    const pagina = regel.closest('[data-banky-cart-pagina]') ? paginaSectieId() : null;
    if (pagina) secties.push(pagina);
    let pad, body;
    // Duo-bundels (21-10): een rij met een verborgen bundel van 2 stuks (data-banky-duo, snippets/banky-cart-line.liquid). Het
    // nieuwe aantal stuks n wordt floor(n/2) bundels en n mod 2 los, in één update.js: de eerste regel van elk krijgt het doel,
    // de rest 0, zonder regel het variant-id. Van 2 naar 1 blijft er dus 1 los staan, niet de hele bundel weg.
    const duo = !verwijder && regel.dataset.bankyDuo ? regel.dataset.bankyDuo.split(':') : null;
    if (duo && duo[0] && duo[1]) {
      const n = Math.max(0, Number(regel.dataset.bankyAantal || 0) + Number(link.dataset.bankyStap || 0));
      const updates = {};
      const zet = (lijst, id, doel) => {
        const k = String(lijst || '').split(',').filter(Boolean);
        k.forEach((x, i) => { if (!(x in updates)) updates[x] = i === 0 ? doel : 0; });
        if (!k.length && doel > 0) updates[id] = doel;
      };
      // Zonder geldige wissel (derde deel 0: wissel uit, actie voorbij, prijs klopt niet; review 21-10) alles los: de stap
      // verandert precies 1 stuk en er komt geen nieuwe bundel (banky-duo-plan zet een oude bundel ook terug).
      const geldig = duo[2] !== '0';
      zet(regel.dataset.bankyDuoLos, duo[0], geldig ? n % 2 : n);
      zet(regel.dataset.bankyDuoBundel, duo[1], geldig ? Math.floor(n / 2) : 0);
      pad = 'cart/update.js';
      body = {updates, sections: [...new Set(secties)]};
    } else if (verwijder) {
      pad = 'cart/update.js';
      body = {updates: Object.fromEntries((sleutels.length ? sleutels : [u.searchParams.get('id')]).map(k => [k, 0])), sections: [...new Set(secties)]};
    } else {
      pad = 'cart/change.js';
      body = {id: u.searchParams.get('id'), quantity: Number(u.searchParams.get('quantity')), sections: [...new Set(secties)]};
    }
    const uitvoer = regel.querySelector('.banky-stepper__waarde');
    const oud = uitvoer ? uitvoer.textContent : '';
    if (uitvoer && !verwijder) uitvoer.textContent = String(Math.max(0, Number(regel.dataset.bankyAantal || oud) + Number(link.dataset.bankyStap || 0)));
    regel.setAttribute('aria-busy', 'true');
    regel.querySelector('pill-loader')?.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(wortelUrl() + pad, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
      const json = await r.json();
      if (!r.ok) throw new Error((json && json.description) || teksten().fout);
      if (pagina && !(json.sections && json.sections[pagina])) { location.reload(); return; }
      if (pagina) vervangPagina(json.sections[pagina]);
      verstuurWijziging(json);
    } catch (fout) {
      if (uitvoer) uitvoer.textContent = oud;
      regel.removeAttribute('aria-busy');
      regel.querySelector('pill-loader')?.removeAttribute('aria-busy');
      const tekst = (fout && fout.message) || teksten().fout;
      regelFout(regel, tekst);
      // De lade weer gelijk aan de winkelwagen; Halo vervangt daarna de regels (setTimeout 0), dus de melding daarna
      // opnieuw bij de rij van dezelfde variant, zodat hij blijft staan tot de volgende wijziging.
      const variant = String(regel.dataset.key || '').split(':')[0];
      await synchroniseer();
      setTimeout(() => document.querySelectorAll('.banky-cart-regel[data-key]').forEach(r => {
        if (String(r.dataset.key).split(':')[0] === variant && !r.querySelector('[data-banky-cart-fout]')) regelFout(r, tekst);
      }), 60);
    }
  }
  function vervangPagina(html) {
    const oud = document.querySelector('[data-banky-cart-pagina]')?.closest('.shopify-section');
    if (!oud) return;
    const tijdelijk = document.createElement('div');
    tijdelijk.innerHTML = html;
    const vers = tijdelijk.querySelector('.shopify-section') || tijdelijk.firstElementChild;
    if (vers) oud.replaceChildren(...vers.childNodes);
    paginaBeelden();
    verzendSchatter();
  }
  // De foto's van "Maak het compleet" en het dealblok laden in de lade pas bij openen (data-banky-src); op de pagina meteen.
  const paginaBeelden = () => document.querySelectorAll('[data-banky-cart-pagina]').forEach(laadBeelden);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paginaBeelden); else paginaBeelden();
  document.addEventListener('click', e => {
    const link = e.target.closest && e.target.closest('.banky-cart-regel [data-banky-stap], .banky-cart-regel [data-banky-verwijder]');
    if (!link) return;
    const regel = link.closest('.banky-cart-regel');
    if (!regel || !regel.dataset.bankySleutels) return;
    e.preventDefault();
    e.stopPropagation();
    wijzigRegel(regel, link, link.hasAttribute('data-banky-verwijder'));
  }, true);

  // Verzendkosten op /cart (punt 11): Nederland voorgekozen (Halo zocht alleen het land van een ingelogde klant), en de
  // uitkomst als "Voordelige verzending: €4,95" in plaats van "EUR 4.95".
  function verzendSchatter() {
    document.querySelectorAll('shipping-estimator').forEach(schatter => {
      const land = schatter.querySelector('[name="address[country]"]');
      if (land && (land.selectedIndex <= 0 || land.value === '---')) {
        const doel = [...land.options].findIndex(o => o.value === 'Netherlands' || o.value === 'NL' || o.textContent.trim() === 'Nederland');
        if (doel > 0) { land.selectedIndex = doel; land.dispatchEvent(new Event('change')); }
      }
      const uit = schatter.querySelector('.shipping-estimator__results');
      if (!uit || uit.bankyNet) return;
      uit.bankyNet = new MutationObserver(() => uit.querySelectorAll('li').forEach(li => {
        const m = /^(.*):\s*([A-Z]{3})\s*([\d.,]+)$/.exec(li.textContent.trim());
        if (!m) return;
        const bedrag = Math.round(parseFloat(m[3].replace(',', '.')) * 100);
        li.textContent = bedrag === 0 ? m[1] : m[1] + ': ' + geld(bedrag);
      }));
      uit.bankyNet.observe(uit, {childList: true, subtree: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(verzendSchatter, 0)); else setTimeout(verzendSchatter, 0);

  window.bankyCart = {bevestig: naToevoegen, ververs, koppel, synchroniseer, verzendSchatter};
})();
